import Swal from 'sweetalert2';

export const showToast = ({ icon = 'success', title = '', text = '', timer = 5000 }) => {
    return Swal.fire({
        toast: true,
        position: 'top-end',
        icon,
        title,
        text,
        showConfirmButton: false,
        timer,
        timerProgressBar: true,
        showCloseButton: true
    });
};

export const showConfirmDialog = async ({
    title = 'Are you sure?',
    html = 'You won’t be able to revert this!',
    confirmButtonText = 'Yes, do it!',
    cancelButtonText = 'Cancel',
    confirmButtonClass = 'rlms-btn rlms-btn-danger',
    cancelButtonClass = 'rlms-btn rlms-btn-outline-primary',
    imageUrl = null,
    icon = null,
    confirmButtonColor = '#d33',
    cancelButtonColor = '#3085d6',
}) => {
    return Swal.fire({
        icon,
        title,
        html,
        imageUrl,
        imageWidth: imageUrl ? 300 : undefined,
        showCancelButton: true,
        confirmButtonColor,
        cancelButtonColor,
        confirmButtonText,
        cancelButtonText,
        allowOutsideClick: false,
        customClass: {
            actions: 'rlms-flex rlms-flex-row-reverse rlms-w-100 rlms-px-5',
            confirmButton: confirmButtonClass,
            cancelButton: cancelButtonClass
        },
        didRender: () => {
            const confirmBtn = document.querySelector(`.${confirmButtonClass.split(' ').join('.')}`);
            const cancelBtn = document.querySelector(`.${cancelButtonClass.split(' ').join('.')}`);
            if (confirmBtn) confirmBtn.style.flex = '1 0 150px';
            if (cancelBtn) cancelBtn.style.flex = '1 0 150px';
        },
        didOpen: () => {
            // Prevent body scroll
            document.body.style.overflow = 'hidden';
        },
        willClose: () => {
            // Restore body scroll
            document.body.style.overflow = '';
        }
    });
};

export const showDialog = ({ title = '', html = '', icon = 'info', imageUrl = null, timer = null }) => {
    return Swal.fire({
        title,
        html,
        imageUrl,
        imageWidth: imageUrl ? 300 : undefined,
        icon,
        showConfirmButton: true,
        timer
    });
};


